<div class='input-container'>
  <div class='input-spacer'>
    <app-spacing-input (valueChange)="handleValueChange($event,'left')" [left]="left > 0" [value]="left"> </app-spacing-input>
  </div>
  <div class='input-spacer'>
    <app-spacing-input (valueChange)="handleValueChange($event, 'top')" [top]="top > 0" [value]="top"> </app-spacing-input>
  </div>
  <div class='input-spacer'>
    <app-spacing-input (valueChange)="handleValueChange($event, 'right')" [right]="right > 0" [value]="right"> </app-spacing-input>
  </div>
  <div class='input-spacer'>
    <app-spacing-input (valueChange)="handleValueChange($event, 'bottom')" [bottom]="bottom > 0" [value]="bottom"> </app-spacing-input>
  </div>
</div>
